import { createJsonMemoryAccessors } from '@/services/storage'

import type {
  Supplier,
  SupplierAuditEntry,
  SupplierCredential,
  SupplierLog,
} from '../types'

const SUPPLIERS_KEY = 'masterhub.suppliers.v1'
const CREDENTIALS_KEY = 'masterhub.supplier-credentials.v1'
const LOGS_KEY = 'masterhub.supplier-logs.v1'
const AUDIT_KEY = 'masterhub.supplier-audit.v1'

type Slot = 'suppliers' | 'credentials' | 'logs' | 'audit'

const memory: Record<Slot, unknown> = {
  suppliers: null,
  credentials: null,
  logs: null,
  audit: null,
}

const accessors = createJsonMemoryAccessors(memory)
export const readJson = accessors.readJson
export const writeJson = accessors.writeJson

export function resetSupplierMemory(): void {
  memory.suppliers = null
  memory.credentials = null
  memory.logs = null
  memory.audit = null
}

export const STORAGE_KEYS = {
  suppliers: SUPPLIERS_KEY,
  credentials: CREDENTIALS_KEY,
  logs: LOGS_KEY,
  audit: AUDIT_KEY,
} as const

export type { Supplier, SupplierCredential, SupplierLog, SupplierAuditEntry }
